import { Button } from "@/components/atoms";
import { clsx } from "@/utils";

interface HowPricingWorksButtonProps {
  onClick: () => void;
  className?: string;
}

export const HowPricingWorksButton = ({ onClick, className }: HowPricingWorksButtonProps) => {
  return (
    <Button 
      variant="secondary" 
      size="sm" 
      endIcon="help-circle" 
      isCustomIcon 
      iconClassName="text-neutral-silver-gray"
      onClick={onClick}
      className={clsx("text-neutral-dark-gray", className)}
    >
      How Pricing Works + Examples
    </Button>
  );
};